import { motion } from "framer-motion";

export function Section({ children, className = "", id, testId }) {
  return (
    <section
      id={id}
      data-testid={testId}
      className={`py-24 md:py-32 ${className}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">{children}</div>
    </section>
  );
}

export function Overline({ children, className = "" }) {
  return <div className={`overline ${className}`}>{children}</div>;
}

export function SectionHeading({ overline, title, kicker, className = "" }) {
  return (
    <div className={`mb-16 ${className}`}>
      {overline && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="overline mb-5"
        >
          {overline}
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F4F4F6] font-light leading-[1.05] tracking-tight max-w-3xl"
      >
        {title}
      </motion.h2>
      {kicker && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="text-[#A0A4AE] text-base md:text-lg max-w-2xl mt-6 leading-relaxed"
        >
          {kicker}
        </motion.p>
      )}
    </div>
  );
}
